import { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { historySortByAtom } from 'src/store';
import { SortItems } from './filterAndSortBlocks';
import { useTranslation } from 'react-i18next';
import { DropdownStyled } from 'src/components';

export const SortByDropdown = () => {
  const [sortBy] = useAtom(historySortByAtom);
  const [buttonText, setButtonText] = useState<string>('');
  const { t, i18n } = useTranslation();

  const i18nLang = i18n.resolvedLanguage
    ? i18n.resolvedLanguage.toLowerCase()
    : i18n.language.toLowerCase();

  // Determine width based on language
  const widthClass =
    i18nLang === 'en'
      ? 'w-[203px]'
      : i18nLang === 'es'
        ? 'w-[267px]'
        : i18nLang === 'ru'
          ? 'w-[242px] 2xl:w-[362px]'
          : i18nLang === 'zh'
            ? 'w-[200px]'
            : 'w-[203px]';

  useEffect(() => {
    const selectedValue = t(`history.${sortBy}`);
    setButtonText(selectedValue.split(' - ')[0]);
  }, [sortBy, t]);

  return (
    <DropdownStyled
      className={widthClass}
      buttonContent={
        <>
          <span
            className={`${i18nLang === 'ru' ? 'hidden 2xl:block' : ''} whitespace-nowrap pr-1.5 text-sm font-normal text-cloudGray`}
          >
            {t('history.sort_by')}:
          </span>
          <span className='mr-auto truncate whitespace-nowrap pr-2 text-cloudGray'>
            {buttonText}
          </span>
        </>
      }
    >
      {(closeDropdown) => (
        <SortItems handleClick={closeDropdown} includeLabel={false} />
      )}
    </DropdownStyled>
  );
};
